import React, { useEffect, useRef } from "react";
import { BreadCrumbsInterface } from "../../interfaces/product/product.interface";

interface BreadCrumbsProps {
    breadCrumbs: BreadCrumbsInterface[];
}

export const BreadCrumbs: React.FC<BreadCrumbsProps> = ({ breadCrumbs }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const lastIndex = breadCrumbs.length - 1;

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollLeft = containerRef.current.scrollWidth;
        }
    }, []);

    return (
        <div className="breadcrumbs-wrapper">
            <div className="breadcrumbs-container" ref={containerRef}>
                {breadCrumbs.slice(0, lastIndex).map((breadcrumb, index) => (
                    <span key={index} className="breadcrumb-item text-[12px] md:text-[16px]">
                        {index > 0 && (
                            <span className="mx-2">
                                <svg width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="2" cy="2.5" r="2" fill="#949494"/>
                                </svg>
                            </span>
                        )}

                        {breadcrumb.link ? (
                            <a href={breadcrumb.link} className="hover:underline text-[#585858]">
                                {breadcrumb.name}
                            </a>
                        ) : (
                            <span className="text-black">{breadcrumb.name}</span>
                        )}
                    </span>
                ))}
            </div>
            <span className="breadcrumb-item text-[#585858]">
                <span className="mx-2">
                    <svg width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="2" cy="2.5" r="2" fill="#949494"/>
                    </svg>
                </span>
                <a href={ breadCrumbs[lastIndex].link } className="text-black text-[12px] md:text-[16px] cursor-pointer">{breadCrumbs[lastIndex].name}</a>
            </span>
        </div>
    );
}